module.exports = __webpack_public_path__ + "img/chat.2a68fc02.svg";